export enum BwicStatus {
    scheduled = 1,
    bidding = 2,
    finished = 3,
    canceled = 4
}
